import saveScrollPosition from './saveScrollPosition'

const install = function(Vue) {
  Vue.directive('save-scroll-position', saveScrollPosition)
}

if (window.Vue) {
  window['save-scroll-position'] = saveScrollPosition
  Vue.use(install); // eslint-disable-line
}

saveScrollPosition.install = install
export default saveScrollPosition
